import { IActivity } from '@sdk/contracts';
import { Checkbox, CheckboxChangeEvent, Flex, Modal } from 'antd';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ConditionsListWrapper } from './UnsyncActivityConfirmation.styles';

import { useMutateActivity } from '@/store/activities/useMutateActivity';

type Props = {
  activity: IActivity;
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
};

const MODAL_WIDTH = 572;

export const UnsyncActivityConfirmation: React.FC<Props> = ({
  activity,
  isModalOpen,
  setIsModalOpen
}) => {
  const { t } = useTranslation(['CoursesTranslations', 'DefaultTranslations']);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { unsyncActivity, isWorking } = useMutateActivity();

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsConfirmed(e.target.checked);
  };

  const handleCancel = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    setIsConfirmed(false);
    setIsModalOpen(false);
  };

  const handleUnsyncActivity = () => {
    unsyncActivity(activity._id, {
      onSuccess: () => {
        setIsConfirmed(false);
        setIsModalOpen(false);
      },
      onError: () => {
        setIsConfirmed(false);
      }
    });
  };

  return (
    <Modal
      open={isModalOpen}
      onOk={handleUnsyncActivity}
      onCancel={handleCancel}
      title={t('CoursesTranslations:UNSYNC_ACTIVITY')}
      cancelText={t('DefaultTranslations:CANCEL')}
      okText={t('CoursesTranslations:UNSYNC_ACTIVITY')}
      okButtonProps={{ disabled: !isConfirmed, loading: isWorking }}
      maskClosable={false}
      centered
      width={MODAL_WIDTH}
      wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}>
      <Flex vertical gap={24}>
        <span>
          <Trans
            i18nKey="CoursesTranslations:UNSYNC_ACTIVITY_CONFIRMATION"
            values={{ name: activity.name }}
            components={{ bold: <strong /> }}
          />
        </span>
        <ConditionsListWrapper>
          <span>{t('WHEN_UNSYNCING_SECTION')}</span>
          <ul>
            <li>{t('WHEN_UNSYNCING_ACTIVITY_1')}</li>
            <li>{t('WHEN_UNSYNCING_ACTIVITY_2')}</li>
            <li>{t('WHEN_UNSYNCING_ACTIVITY_3')}</li>
          </ul>
        </ConditionsListWrapper>
        <Checkbox checked={isConfirmed} onChange={handleCheckboxChange}>
          {t('DefaultTranslations:I_CONFIRM_I_UNDERSTAND')}
        </Checkbox>
      </Flex>
    </Modal>
  );
};
